import Api from "../Api"
import Request from "../constants/Request.api"

class Staff extends Api {
  getStaffDetails = user => {
    const request = new Request({
      data: {
        url: "staff/" + user.id,
      },
    })

    return this.getRequest(request)
  }

  searchStaff = search => {
    const request = new Request({
      data: {
        url: "staff/search/" + search,
      },
    })

    return this.getRequest(request)
  }
}

export default Staff
